/* ============
 * Field Transformer
 * ============
 */

import Transformer from './transformer';
import productType from './productType';
import field from './field';

export default class ProductFormTransformer extends Transformer {

  static fetch(model) {
    return {
      id: model.id,
      name: model.name,
      formType: model.form_type,
      productType: model.product_type !== undefined ? productType.fetch(model.product_type) : [],
      fields: model.fields !== undefined ? field.fetchCollection(model.fields) : [],
      information: model.information,
      createdAt: model.created_at,
    };
  }

  static send(model) {
    return {
      id: model.id,
      name: model.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productForm.js